import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import style from './style.module.scss';

const Title = () => <h1 className={style.title}>{translate('assets_sharing.page.delivery.title')}</h1>;

export default Title;
